seedWebApp.controller('IndexContactsController', ['$scope', 'TranslationService', '$window', '$routeParams', 'ContactService',
    function ($scope, TranslationService, $window, $routeParams, ContactService) {

        console.log('IndexContactsController');

        $scope.buildVersion = seedWebApp.buildVersion;
        //Controle tab selecionado
        //$scope.selectedIndex = 0;
        //$scope.selTab = $routeParams.Tab;

        //$scope.tabSelected = function (page) {
        //    $location.search('Tab', page.pageIndex);
        //    $scope.selectedIndex = page.pageIndex;
        //};

        ////$scope.defaultPages = [
        ////    { pageIndex: 0, pageLabel: 'Cotações MBF', pageDisplay: 'Prices/Prices', pageUrl: 'SPA/Prices/mbfPrices.html' },
        ////    { pageIndex: 1, pageLabel: 'Adicionais MBF', pageDisplay: 'Prices/Prices', pageUrl: 'SPA/Prices/mbfAdditionals.html' },
        ////    { pageIndex: 2, pageLabel: 'Preços', pageDisplay: 'Prices/Prices', pageUrl: 'SPA/Prices/Prices.html' },
        ////    { pageIndex: 3, pageLabel: 'Configuração Preços', pageDisplay: 'Prices/Prices', pageUrl: 'SPA/Prices/priceConfig.html' },
        ////];

        //$scope.pages = $scope.defaultPages;

        //PARA INFINITESCROLL FUNCIONAR
        $(document).ready(function () {
            $scope.overflowSize = $scope.AdjustSize();
            console.log('document.ready.AdjustSize ' + $scope.overflowSize);
        });

        $window.onresize = function () {
            $scope.overflowSize = $scope.AdjustSize();
        };

        //ROUTE POINTS
        $scope.updateFormat = 'dd/MM/yyyy HH:mm:ss';
        $scope.routeCols = [
            { name: 'PointID', display: 'ID', orderBy: 'asc', editable: false, width: 5, isKey: true },  //filterOptions: [] 
            { name: 'PointName', display: 'Nome', editable: true, width: 25 },
            { name: 'PointNarrative', display: 'Narrative', editable: true, width: 5 },
            { name: 'cod_uf', display: 'UF', editable: true, width: 5 },
            { name: 'UpdateDate', display: 'UpdateDate', dataType: 'date', format: $scope.updateFormat, width: 5 },
        ];
        $scope.routeLoadService = ContactService.getRoutePoints;


        //COLSHIPS
        console.log('shipCols');
        $scope.shipCols = [
            { name: 'EmitterID', display: 'Emitter', orderBy: 'asc', editable: false, width: 5, isKey: true },  //filterOptions: [] 
            { name: 'AgentID', display: '#Agent', editable: true, width: 5 },
            { name: 'AgentName', display: 'Agent Name', editable: true, width: 25 },
            { name: 'AgentCountry', display: 'Country', editable: true, width: 5 },
            { name: 'UpdateDate', display: 'UpdateDate', dataType: 'date', format: $scope.updateFormat, width: 5 },
        ];


        $scope.shipLoadService = ContactService.getShipOwners;

        //ctrl.resetService = ContactService.resetCache;


    }]);